import React from 'react';

/**
 * Grid Overlay Component
 * Displays a customizable grid over the layout canvas
 */
const GridOverlay = ({ 
    enabled, 
    size = 20, 
    color = '#e2e8f0', 
    opacity = 0.5,
    width,
    height 
}) => {
    if (!enabled) return null;

    return (
        <svg
            className="absolute inset-0 pointer-events-none z-10"
            width={width}
            height={height}
            style={{ opacity }}
        >
            <defs>
                <pattern
                    id="grid-pattern"
                    width={size}
                    height={size}
                    patternUnits="userSpaceOnUse"
                >
                    <path
                        d={`M ${size} 0 L 0 0 0 ${size}`}
                        fill="none"
                        stroke={color}
                        strokeWidth="1"
                    />
                </pattern>
            </defs>
            <rect width="100%" height="100%" fill="url(#grid-pattern)" />
            
            {/* Major grid lines every 5 cells */}
            <defs>
                <pattern
                    id="grid-major-pattern"
                    width={size * 5}
                    height={size * 5}
                    patternUnits="userSpaceOnUse"
                >
                    <path
                        d={`M ${size * 5} 0 L 0 0 0 ${size * 5}`}
                        fill="none"
                        stroke={color}
                        strokeWidth="2"
                    />
                </pattern>
            </defs>
            <rect width="100%" height="100%" fill="url(#grid-major-pattern)" />
        </svg>
    );
};

export default GridOverlay;
